import type { JSX, ComponentProps } from 'solid-js'
import { splitProps } from 'solid-js'

type Variant = 'flat' | 'elevated' | 'outlined'

const CardRoot = (props: ComponentProps<'div'> & { variant?: Variant }): JSX.Element => {
  const [l, rest] = splitProps(props, ['variant', 'class'])
  return (
    <div
      data-variant={l.variant ?? 'flat'}
      class={
        'bg-surface rounded-lg overflow-hidden ' +
        'data-[variant=flat]:bg-surface-alt ' +
        'data-[variant=elevated]:bg-surface data-[variant=elevated]:shadow-md ' +
        'data-[variant=outlined]:bg-surface data-[variant=outlined]:border data-[variant=outlined]:border-border ' +
        (l.class ?? '')
      }
      {...rest}
    />
  )
}
const CardHeader = (props: ComponentProps<'div'>) => <div class={'px-5 py-4 border-b border-border ' + (props.class ?? '')} {...props} />
const CardBody = (props: ComponentProps<'div'>) => <div class={'px-5 py-4 ' + (props.class ?? '')} {...props} />
const CardFooter = (props: ComponentProps<'div'>) => <div class={'px-5 py-3 border-t border-border bg-surface-alt ' + (props.class ?? '')} {...props} />

export const Card = Object.assign(CardRoot, { Header: CardHeader, Body: CardBody, Footer: CardFooter })
